import { useTranslation } from 'react-i18next';

import { ButtonLink } from '~/components/button-link';
import { trackEvent } from '~/features/analytics/track-event';
import { BriefCaseIcon, UserIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';
import { FooterBannerSection } from '~/features/page-template/templates/enterprise-overview/components/footer-banner-section';

export function PlansFooterBannerSection() {
  const { t } = useTranslation();
  return (
    <FooterBannerSection
      description='Find the right solution for your goals.'
      title='Ready to get started?'
      ctaSlot={
        <>
          <ButtonLink
            buttonProps={{
              leftIcon: <UserIcon height='20px' width='20px' />,
              flex: {
                base: 1,
                md: 'unset',
              },
              onClick: () =>
                trackEvent({
                  name: 'Plans CTA Clicked',
                  type: 'click',
                  label: 'plans_footer_option_clicked',
                  value: 'Individuals',
                }),
            }}
            linkProps={{
              href: '/experience',
            }}
          >
            {t('common.forIndividuals')}
          </ButtonLink>
          <ButtonLink
            buttonProps={{
              leftIcon: <BriefCaseIcon height='20px' width='20px' />,
              variant: 'outline',
              colorScheme: 'white',
              flex: {
                base: 1,
                md: 'unset',
              },
              onClick: () =>
                trackEvent({
                  name: 'Plans CTA Clicked',
                  type: 'click',
                  label: 'plans_footer_option_clicked',
                  value: 'Businesses',
                }),
            }}
            linkProps={{
              href: '/enterprise/overview',
            }}
          >
            {t('common.forBusinesses')}
          </ButtonLink>
        </>
      }
    />
  );
}
